var React = require('react');

function CornerTick (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"6","cy":"6","r":"5.5","transform":"rotate(-90 6 6)","stroke":"#F0EFDD","key":0}),React.createElement("path",{"d":"M5.5 15.5L5.5 6L15.5 6","stroke":"#F0EFDD","key":1})]);
}

CornerTick.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = CornerTick;

CornerTick.default = CornerTick;
